import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import Measure from "react-measure";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";
import { bool, number, string, shape, arrayOf } from "prop-types";
import * as i18n from "util/i18n";
import { actions as loginActions } from "reducers/login";
import { actions as sessionActions, selectors as sessionSelectors } from "reducers/session";
import { actions as onboardingActions } from "reducers/onboarding";
import { signaturesSchemesSelectors } from "reducers/administration";
import { signaturesSchemesActions } from "reducers/administration/advanced";
import Head from "pages/_components/Head";
import Image from "pages/_components/Image";
import Drawer from "pages/_components/Drawer/Drawer";
import CustomData from "pages/_components/CustomData/CustomData";
import GridTable from "pages/_components/GridTable/GridTable";
import Container from "pages/_components/Container";
import Scroll from "pages/_components/Scroll";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";

import SignaturesSchemeItem from "./SignaturesSchemeItem";

const SignaturesSchemes = ({
    activeEnvironment,
    isDesktop,
    currentPage,
    fetching,
    // fetchingMoreSignaturesSchemes,
    hasMoreData,
    signaturesSchemes,
    totalPages,
    user,
}) => {
    const dispatch = useDispatch();
    const [showSidebar, setShowSidebar] = useState(false);
    const [dimensions, setDimensions] = useState(null);

    useEffect(() => {
        setShowSidebar(true);
        dispatch(signaturesSchemesActions.listSignaturesSchemesRequest());
    }, []);

    useEffect(() => {
        if (!fetching) {
            setShowSidebar(true);
        }
    }, [fetching]);

    const columns = isDesktop ? 4 : 1;

    const listSignaturesSchemes = () =>
        signaturesSchemes.map((signatureScheme) => (
            <GridTable.Container
                key={signatureScheme.idSignature}
                columns={columns}
                rows={1}
                columnsTemplate="fixed"
                renderAs="div">
                <SignaturesSchemeItem
                    key={`signatureScheme-${signatureScheme.idSignature}`}
                    signatureScheme={signatureScheme}
                    isDesktop={isDesktop}
                    administrationScheme={activeEnvironment?.administrationScheme}
                    type={activeEnvironment?.type}
                />
            </GridTable.Container>
        ));

    const endOfListItem = () => (
        <div className="table-row" key="noMoreMovements">
            <div className="table-data">
                <I18n id="administration.signatures.list.more.noMoreData" />
            </div>
        </div>
    );

    const fetchMoreData = () => {
        signaturesSchemesActions.loadMoreRequest({ pageNumber: currentPage + 1 });
    };

    const tableHeader = () => (
        <GridTable.Header>
            <GridTable.Container columns={columns} columnsTemplate="fixed">
                <GridTable.Data columnStart={1} columnWidth={1} alignX="center" alignY="center">
                    <I18n id="administration.signatures.list.signers" />
                </GridTable.Data>
                <GridTable.Data columnStart={2} columnWidth={1} alignX="center" alignY="center">
                    <I18n id="administration.signatures.list.transactions" />
                </GridTable.Data>
                <GridTable.Data columnStart={3} columnWidth={1} alignX="center" alignY="center">
                    <I18n id="administration.signatures.list.functionalGroups" />
                </GridTable.Data>
                <GridTable.Data columnStart={4} columnWidth={1} alignX="center" alignY="center">
                    <I18n id="administration.signatures.list.amountPerPeriod" />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Header>
    );

    const sidebar = () => (
        <Drawer className="qr-slider" openSidebar={showSidebar} enableCloseButton={false}>
            <div className="container" style={{ width: "80%" }}>
                <MainContainer className="main-container onboarding-layout">
                    <div className="above-the-fold">
                        <Container className="flex-grow items-center container--layout">
                            <div className="media-object media-object--state-error">
                                <div className="media-object--text">
                                    <h2 className="title-content">
                                        <I18n id="" defaultValue="Conoce el esquema de firmas" component="h1" />
                                    </h2>
                                </div>
                            </div>

                            <figure className="justify-center flex">
                                <Image src="images/figma/illustrations/onboarding15.svg" />
                            </figure>
                            <div className="media-object media-object--state-error">
                                <div className="media-object--text">
                                    <I18n
                                        id=""
                                        defaultValue="Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias."
                                        component="span"
                                    />
                                </div>
                            </div>
                            <Button
                                bsStyle="primary"
                                label="global.ok"
                                onClick={() => {
                                    setShowSidebar(false);
                                }}
                                defaultLabelText="Conocer"
                                block
                            />
                        </Container>
                    </div>
                </MainContainer>
            </div>
        </Drawer>
    );

    const onCancel = () => {
        dispatch(loginActions.reset());
        dispatch(sessionActions.logout());
        dispatch(push("/"));
    };

    const handleClickAccept = () => {
        dispatch(onboardingActions.acceptScheme(user?.userData?.idUser, user.environmentData?.idEnvironment));
    };
    return (
        <>
            <Notification scopeToShow="signaturesScheme" />
            <Head title="administration.signatures.list.title" />
            {sidebar()}
            {isDesktop ? (
                <>
                    <MainContainer showLoader={fetching} showChildrenWithLoader>
                        <div className="above-the-fold">
                            <Container className="container--layout flex-grow no-scrollable">
                                <Col className="col-12 ">
                                    <div className="flex-container">
                                        <h2>{i18n.get("administration.signatures.index.title")}</h2>
                                    </div>
                                    <div>
                                        {signaturesSchemes !== null && signaturesSchemes.length ? (
                                            <GridTable className="movements-table underlined">
                                                {tableHeader()}
                                                <GridTable.Body>{listSignaturesSchemes()}</GridTable.Body>
                                            </GridTable>
                                        ) : (
                                            <div className="text-center no-more-data" key="noMoreMovements">
                                                <div className="illustration-wrapper">
                                                    <Image
                                                        src="images/coloredIcons/folder-empty.svg"
                                                        className="svg-big-icon"
                                                    />
                                                </div>
                                                <p className="text-lead">
                                                    <I18n id="administration.signatures.list.noRecords" />
                                                </p>
                                            </div>
                                        )}
                                        {totalPages > 1 &&
                                            (hasMoreData ? (
                                                <div className="text-center no-more-data" key="noMoresignatures">
                                                    <Button
                                                        bsStyle="link"
                                                        onClick={fetchMoreData}
                                                        image="images/figma/icon/arrow.svg"
                                                        label="administration.signatures.list.more"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="text-center no-more-data" key="noMoreSignatures">
                                                    <p className="text-lead">
                                                        <I18n id="administration.signatures.list.more.noMoreData" />
                                                    </p>
                                                </div>
                                            ))}
                                    </div>
                                </Col>
                                <Row>
                                    <div className="container--alert" role="alert" style={{ paddingBottom: "15px" }}>
                                        <div className="alert alert-warning">
                                            <CustomData
                                                icon="alert.svg"
                                                titleText="Aceptá el esquema de firmas para comenzar a operar. Si necesitás realizar una modificación al esquema, comunicate con BiBank."
                                                keepSpaceIfNoValue={false}
                                            />
                                        </div>
                                    </div>
                                    <Col className="col-6">
                                        <Button
                                            bsStyle="outline"
                                            label="global.ok"
                                            onClick={onCancel}
                                            defaultLabelText="Cancelar"
                                            block
                                        />
                                    </Col>
                                    <Col className="col-6">
                                        <Button
                                            bsStyle="primary"
                                            label="global.ok"
                                            onClick={handleClickAccept}
                                            defaultLabelText="Aceptar"
                                            block
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </MainContainer>
                </>
            ) : (
                <>
                    <MainContainer showLoader={fetching} showChildrenWithLoader>
                        <div className="above-the-fold">
                            <div className="flex-container">
                                <h2>{i18n.get("administration.signatures.index.title")}</h2>
                            </div>
                            {signaturesSchemes !== null && !signaturesSchemes.length ? (
                                <div className="text-center no-more-data" key="noMoreSignatures">
                                    <div className="illustration-wrapper">
                                        <Image src="images/coloredIcons/folder-empty.svg" className="svg-big-icon" />
                                    </div>
                                    <p className="text-lead">
                                        <I18n id="administration.signatures.list.noRecords" />
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <Notification scopeToShow="signaturesScheme" />
                                    <Measure
                                        bounds
                                        onResize={(contentRect) => {
                                            if (!dimensions) {
                                                setDimensions(contentRect.bounds);
                                            }
                                        }}>
                                        {({ measureRef }) => (
                                            <div className="containerDetails container-fluid" ref={measureRef}>
                                                <GridTable className="transactions-list">
                                                    <GridTable.Body>
                                                        {dimensions && (
                                                            <Scroll
                                                                containerHeight={(window.innerHeight * 80) / 100}
                                                                endOfListItem={endOfListItem()}
                                                                fetchMoreData={fetchMoreData()}
                                                                lastPage={!hasMoreData}
                                                                isInfiniteScroll
                                                                items={listSignaturesSchemes()}
                                                                removeListenersWhenPulled
                                                            />
                                                        )}
                                                    </GridTable.Body>
                                                </GridTable>
                                                <div>
                                                    <div
                                                        className="container--alert"
                                                        role="alert"
                                                        style={{ paddingBottom: "15px" }}>
                                                        <div className="alert alert-warning">
                                                            <CustomData
                                                                icon="alert.svg"
                                                                titleText="Aceptá el esquema de firmas para comenzar a operar. Si necesitás realizar una modificación al esquema, comunicate con BiBank."
                                                                keepSpaceIfNoValue={false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <Button
                                                        bsStyle="primary"
                                                        label="global.ok"
                                                        onClick={handleClickAccept}
                                                        defaultLabelText="Aceptar"
                                                        block
                                                    />
                                                    <Button
                                                        bsStyle="outline"
                                                        label="global.ok"
                                                        onClick={onCancel}
                                                        defaultLabelText="Cancelar"
                                                        block
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </Measure>
                                </>
                            )}
                        </div>
                    </MainContainer>
                </>
            )}
        </>
    );
};

SignaturesSchemes.propTypes = {
    activeEnvironment: shape({ type: string }).isRequired,
    isDesktop: bool.isRequired,
    currentPage: number.isRequired,
    fetching: bool.isRequired,
    // fetchingMoreSignaturesSchemes: bool.isRequired,
    hasMoreData: bool.isRequired,
    signaturesSchemes: arrayOf(
        shape({
            capList: arrayOf(shape({ maximum: number })),
            idSignature: number,
            signatureType: string,
        }),
    ).isRequired,
    totalPages: number.isRequired,
    user: string.isRequired,
};

const mapStateToProps = (state) => ({
    user: sessionSelectors.getUser(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    currentPage: signaturesSchemesSelectors.currentPage(state),
    fetching: signaturesSchemesSelectors.fetching(state),
    // fetchingMoreSignaturesSchemes: signaturesSchemesSelectors.isFetchingMoreSignaturesSchemes(state),
    hasMoreData: signaturesSchemesSelectors.hasMoreData(state),
    signaturesSchemes: signaturesSchemesSelectors.signaturesSchemes(state),
    totalPages: signaturesSchemesSelectors.totalPages(state),
});

export default connect(mapStateToProps)(SignaturesSchemes);
